import React, { useState } from 'react';
import { Play, Image as ImageIcon, AlertCircle, ExternalLink } from 'lucide-react';

export const PostMedia = ({ post }) => {
  const [opened, setOpened] = useState(false);
  const [failed, setFailed] = useState(false);
  const [index, setIndex] = useState(0);
  const urls = post.media_urls || [];
  if (!urls.length) return null;
  const url = urls[index];
  const video = post.media_type === 'video' || /\.(mp4|mov|webm|m4v)(\?|#|$)/i.test(url);
  return (
    <div className="min-w-0" onClick={e => e.stopPropagation()}>
      <div className="bg-white/5 aspect-video rounded-lg flex items-center justify-center overflow-hidden">
        {!opened ? (
          <button type="button" data-testid={`post-media-open-${post.id}`} onClick={() => setOpened(true)}
            aria-label={video ? 'Play video preview' : 'Open image preview'}
            className="w-full h-full flex items-center justify-center gap-2 text-white/60 hover:text-emerald-300 hover:bg-white/5 transition-colors">
            {video ? <Play size={24} /> : <ImageIcon size={24} />}
            <span className="text-xs">{video ? 'Play video' : urls.length > 1 ? `${urls.length} images` : 'Preview image'}</span>
          </button>
        ) : failed ? (
          <div data-testid={`post-media-error-${post.id}`} className="p-3 text-xs text-white/60 flex flex-col items-center gap-2">
            <AlertCircle size={20} /> Preview unavailable
            <a href={url} target="_blank" rel="noopener noreferrer" data-testid={`post-media-original-${post.id}`}
              className="text-emerald-300 flex items-center gap-1">Open original <ExternalLink size={12} /></a>
          </div>
        ) : video ? (
          <video key={url} src={url} controls autoPlay playsInline preload="none" onError={() => setFailed(true)}
            data-testid={`post-video-${post.id}`} className="w-full h-full object-contain" />
        ) : (
          <img src={url} alt="Post attachment" loading="lazy" decoding="async" onError={() => setFailed(true)}
            data-testid={`post-image-${post.id}`} className="w-full h-full object-contain" />
        )}
      </div>
      {opened && urls.length > 1 && (
        <div className="flex items-center justify-between text-xs text-white/60 mt-2" data-testid={`post-media-pager-${post.id}`}>
          <button type="button" disabled={index === 0} data-testid={`post-media-prev-${post.id}`}
            onClick={() => { setIndex(index - 1); setFailed(false); }} className="disabled:opacity-30">Previous</button>
          <span>{index + 1} / {urls.length}</span>
          <button type="button" disabled={index === urls.length - 1} data-testid={`post-media-next-${post.id}`}
            onClick={() => { setIndex(index + 1); setFailed(false); }} className="disabled:opacity-30">Next</button>
        </div>
      )}
    </div>
  );
};